import { Link } from "react-router-dom";

const NurseHayley = () => {
  return (
    <div className="bg-secondary/5 p-8 rounded-lg">
      <Link to="/about#hayley" className="group">
        <div className="flex items-center gap-6 mb-6">
          <img
            src="/lovable-uploads/ddda7171-f98c-4340-a038-c5d9952b0df5.png"
            alt="Cosmetic Nurse Hayley"
            className="w-32 h-32 rounded-full object-cover transition-transform group-hover:scale-105"
          />
          <div>
            <h3 className="text-xl font-semibold">Cosmetic Nurse Hayley</h3>
            <p className="text-gray-600">Advanced Aesthetic Practitioner</p>
          </div>
        </div>
      </Link>
      <div className="prose prose-lg">
        <p className="text-gray-600">
          Nurse Hayley is our highly skilled aesthetic nurse practitioner, bringing her expertise and passion for aesthetic medicine to Evolutions Medspa. With advanced training in facial aesthetics and injectable treatments, she combines technical precision with an artistic eye to deliver beautiful, natural-looking results.
        </p>
        <p className="text-gray-600">
          Her gentle approach and commitment to patient education ensure that each client feels comfortable and informed throughout their aesthetic journey. Specializing in facial rejuvenation and enhancement procedures, Nurse Hayley takes pride in helping clients achieve their aesthetic goals while maintaining their unique features.
        </p>
      </div>
    </div>
  );
};

export default NurseHayley;